import React, { useState } from 'react';
import { ChevronUpIcon, ChevronDownIcon } from 'lucide-react';
interface Column {
  key: string;
  label: string;
  sortable?: boolean;
}
interface DataTableProps {
  columns: Column[];
  data: any[];
  className?: string;
}
export function DataTable({
  columns,
  data,
  className = ''
}: DataTableProps) {
  const [sortKey, setSortKey] = useState<string | null>(null);
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');
  const handleSort = (key: string) => {
    if (sortKey === key) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortKey(key);
      setSortDirection('asc');
    }
  };
  const sortedData = sortKey ? [...data].sort((a, b) => {
    const aVal = a[sortKey];
    const bVal = b[sortKey];
    if (typeof aVal === 'string') {
      return sortDirection === 'asc' ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
    }
    return sortDirection === 'asc' ? aVal - bVal : bVal - aVal;
  }) : data;
  return <div className={`overflow-x-auto ${className}`} data-id="element-326" data-mp="6jl6mg0a0mzh">
      <table className="w-full" data-id="element-327" data-mp="1l03a7pq9n6t">
        <thead className="bg-au-green-light" data-id="element-328" data-mp="1lt9n7kryaof">
          <tr data-id="element-329" data-mp="3szpd7vo3f90n">
            {columns.map(col => <th key={col.key} className={`px-6 py-4 text-left text-sm font-bold text-charcoal ${col.sortable ? 'cursor-pointer hover:bg-au-green hover:text-white transition-colors' : ''}`} onClick={() => col.sortable && handleSort(col.key)} data-id="element-330" data-mp="3sy4hw3tyfm1q">
                <div className="flex items-center gap-2" data-id="element-331" data-mp="3f294uem8l569">
                  {col.label}
                  {col.sortable && sortKey === col.key && (sortDirection === 'asc' ? <ChevronUpIcon size={16} data-id="element-332" data-mp="189q61oevh3z3" /> : <ChevronDownIcon size={16} data-id="element-333" data-mp="188x5j56ibape" />)}
                </div>
              </th>)}
          </tr>
        </thead>
        <tbody className="bg-white" data-id="element-334" data-mp="2xqlpthjj7fpr">
          {sortedData.map((row, index) => <tr key={index} className="border-b border-gray-border hover:bg-gray-50 transition-colors" data-id="element-335" data-mp="32hak14mliqsl" data-mpi={index}>
              {columns.map(col => <td key={col.key} className="px-6 py-4 text-sm text-gray-700" data-id="element-336" data-mp="2srqz7tfbomv3">
                  {row[col.key]}
                </td>)}
            </tr>)}
        </tbody>
      </table>
    </div>;
}